import React from 'react'
import { useTranslation } from 'react-i18next'
import { getIcon } from '../../common/components/icons/utils'
import { Tooltip } from '../../common/components/tooltip/Tooltip'
import styles from './GameRatingModal.module.css'
import { TGameRating } from '../../types/commonTypes'

type StarRatingProps = {
  rating: TGameRating | undefined
  handleOpenRating: () => void
}

export const StarRating: React.FC<StarRatingProps> = ({ rating, handleOpenRating }) => {
  const { t } = useTranslation()
  const avarageStars: number = rating ? +rating.average : 0

  return (
    <Tooltip tooltipContent={t('rating.rating_tooltip', 'Game ratings')}>
      {(tooltipProps) => (
        <button type='button' onClick={handleOpenRating} className={styles.cardRatingStars} {...tooltipProps}>
          {rating !== undefined ? (
            <>
              <div className={styles.carStar}>
                {getIcon(avarageStars >= 1 ? 'star' : avarageStars >= 0.5 ? 'starHalf' : 'starOutline')}
              </div>
              <div className={styles.carStar}>
                {getIcon(avarageStars >= 2 ? 'star' : avarageStars >= 1.5 ? 'starHalf' : 'starOutline')}
              </div>
              <div className={styles.carStar}>
                {getIcon(avarageStars >= 3 ? 'star' : avarageStars >= 2.5 ? 'starHalf' : 'starOutline')}
              </div>
              <div className={styles.carStar}>
                {getIcon(avarageStars >= 4 ? 'star' : avarageStars >= 3.5 ? 'starHalf' : 'starOutline')}
              </div>
              <div className={styles.carStar}>
                {getIcon(avarageStars >= 5 ? 'star' : avarageStars >= 4.5 ? 'starHalf' : 'starOutline')}
              </div>
            </>
          ) : (
            <div className={styles.cardStar}>{getIcon('starOutline')}</div>
          )}
        </button>
      )}
    </Tooltip>
  )
}
